<template>
  <div class="row">
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <v-toolbar flat :color="themeColor">
              <v-toolbar-title class="white--text"> {{ title }} </v-toolbar-title>
              <v-spacer />
            </v-toolbar>

            <v-stepper v-model="next">
              <v-stepper-header>
                <v-stepper-step
                  :complete="next > 1"
                  step="1"
                >
                  Datos
                </v-stepper-step>

                <v-divider />

                <v-stepper-step
                  :complete="next > 2"
                  step="2"
                >
                  Roles
                </v-stepper-step>

                <v-divider />

                <v-stepper-step
                  :complete="next > 3"
                  step="3"
                >
                  Permisos
                </v-stepper-step>
              </v-stepper-header>
             <v-stepper-items>
                <v-stepper-content step="1">
                  <v-layout
                    :id="ref"
                    class="wrap justify-space-around form-body"
                  >
                    <v-col cols="6">
                      <v-text-field
                        v-model="form.name"
                        :rules="[rules.required]"
                        :maxlength="100"
                        label="Nombre"
                        placeholder="Pedro Perez"
                        required
                      />
                    </v-col>

                    <v-col cols="6">
                      <v-text-field
                        v-model="form.email"
                        :rules="[rules.required, rules.emailFormat]"
                        :maxlength="100"
                        label="Correo Electrónico"
                        placeholder="email@dominio.com"
                        required
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="form.identificator"
                        :rules="[rules.required, rules.identificatorFormat, rules.identificatorLength]"
                        :maxlength="20"
                        label="Identificación"
                        placeholder="Cédula"
                        required
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="form.phone"
                        label="Teléfono"
                        placeholder="####-#### / ######-####-####"
                        maxlength="16"
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-select
                        v-model="form.cat_province_id"
                        :items="itemsProvince"
                        item-value="id"
                        item-text="name"
                        label="Provincia"
                        @change="getDistrito()"
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-select
                        v-model="form.cat_district_id"
                        :items="itemsDistrict"
                        item-value="id"
                        item-text="name"
                        label="Distrito"
                        @change="getCorregimiento()"
                      />
                    </v-col>

                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-select
                        v-model="form.cat_corregimiento_id"
                        :items="itemsCorregimiento"
                        item-value="id"
                        item-text="name"
                        label="Corregimiento"
                      />
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        v-model="form.address"
                        :maxlength="300"
                        label="Dirección"
                        placeholder="Ave. La Paz, entre calles 74A y 75. El Ingenio, Bethania. Ciudad de Panamá"
                      />
                    </v-col>
                    <v-btn
                      color="success"
                      @click="validarDatos()"
                    >
                      Siguiente
                    </v-btn>
                  </v-layout>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <v-layout class="wrap justify-space-around form-body">
                    <v-col cols="12">
                      <v-select
                        v-model="form.role"
                        :items="items_role"
                        :rules="[rules.required]"
                        label="Tipo de Usuario"
                        @change="selectRol()"
                      />
                    </v-col>

                    <v-btn
                      :color="themeColor"
                      class="white--text"
                      @click="next = 1"
                    >
                      regresar
                    </v-btn>
                    <v-btn
                      :color="themeColor"
                      class="white--text"
                      @click="validarRol()"
                    >
                      Siguiente
                    </v-btn>
                  </v-layout>
                </v-stepper-content>
                <v-stepper-content step="3">
                  <v-layout class="wrap justify-space-around form-body">
                    <v-row class="custom-good-table" align="center" justify="space-around">
                      <v-col cols="12"  v-if="loadedPermissions">
                        <vue-good-table
                          ref="Permisos"
                          :columns="columns"
                          :rows="rows"
                          :group-options="{
                            enabled: true,
                            collapsable: true
                          }"
                          :select-options="{
                            enabled: true,
                            selectionText: 'Permisos seleccionados',
                            clearSelectionText: 'Limpiar',
                            selectAllByGroup: true,
                          }"
                          @on-selected-rows-change="selectionChanged"
                        >
                        </vue-good-table>
                      </v-col>
                      <v-skeleton-loader
                        v-else
                        max-width="1700px"
                        type="table-tbody"
                      ></v-skeleton-loader>
                    </v-row>
                    <v-row align="center" justify="space-around">
                      <v-btn
                        :color="themeColor"
                        class="white--text"
                        @click="next = 2"
                      >
                        regresar
                      </v-btn>
                      <v-btn
                        color="success"
                        class="white--text"
                        @click="save"
                      >
                        Guardar
                      </v-btn>
                      <v-btn
                        color="red"
                        class="white--text"
                        @click="cancel"
                      >
                        Cancelar
                      </v-btn>
                    </v-row>
                  </v-layout>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Form from 'vform';
  import { mapGetters } from 'vuex';
  import { mask } from 'vue-the-mask';

  export default {
    directives: {
      mask,
    },
    metaInfo() {
      return { title: this.$t('systemUsers') };
    },
    props: {
      dealerId: { default: '0' },
      id: { default: '' },
    },
    data: () => ({
      form: new Form({
        id: '',
        name: '',
        email: '',
        identificator: '',
        phone: '',
        cat_corregimiento_id: '',
        cat_district_id: '',
        cat_province_id: '',
        address: '',
        role: 1,
        busy: false,
        active: false,
        items_permission: [],
      }),
      loadedPermissions: false,
      columns: [
        {
          label: 'Permiso',
          field: 'name',
        },
      ],
      rows: [],
      next: 1,
      items: [],
      itemsProvince: [],
      itemsDistrict: [],
      itemsCorregimiento: [],
      valid: false,
      items_role: [],
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
        emailFormat: (v) => /.+@.+\..+/.test(v) || 'El campo debe tener un correo electrónico válido.',
        identificatorLength: (v) => (v.length >= 5 && v.length <= 20) || 'El campo debe tener de 5 a 20 caracteres.',
        identificatorFormat: (v) => /^(([P][E][-](([-]|[0-9]){1,17})|[N][-](([-]|[0-9]){1,18})|[E][-](([-]|[0-9]){1,18})|(([-]|[0-9]){5,20}))|(((([0-9]{1})[-][A][V][-](([-]|[0-9]){1,15}))|(([0-9]{2})[-][A][V][-](([-]|[0-9]){1,14})))|((([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,15}))|(([0-9]{1,2})[-][N][T][-](([-]|[0-9]){1,14}))|([N][T][-](([-]|[0-9]){1,14}))|(([0-9]{1,2})[-][P][I][-](([-]|[0-9]){1,14}))|([P][I][-](([-]|[0-9]){1,14}))|(([0-9]){1,2}[P][I][-](([-]|[0-9]){1,14})))))$/.test(v)
        || 'El campo debe tener un formato válido.',
      },
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: 'Usuarios del Distribuidor',
      apiURL: '/api/catalogs/dealers',
      method: 'POST',
    }),
    computed: {
      ...mapGetters({
        themeColor: 'theme/themeColor',
      }),
      ref() { return this.form.id; },
    },
    watch: {
      'form.cat_province_id': {
        handler() {
          this.getDistrito();
        },
      },
      'form.cat_district_id': {
        handler() {
          this.getCorregimiento();
        },
      },
    },
    async mounted() {
      await this.getRoles().then((response) => {
        const roles = response.data.items.map((rol) => ({ value: rol.id, text: rol.name }));
        this.items_role = roles;
      });
      await this.getProvincia().then((response) => {
        this.itemsProvince = response.data;
      });
      const URL = `${this.apiURL}/${this.dealerId}/store`;
      this.URL = URL;
      if (this.id) {
        window.axios.get(`${this.apiURL}/${this.dealerId}/users/${this.id}/edit`)
        .then((result) => {
          Object.assign(this.form, result.data);
          this.URL = `${this.apiURL}/${this.dealerId}/users/${this.id}/update`;
          this.method = 'PUT';
          this.title = 'Editar usuario del sistema';
          this.message = `Se ha editado el usuario ${result.data.name} exitosamente.`;
          const permissions = result.data.permissions.map((permission) => (permission.id));
          this.form.items_permission = permissions;
        });
      }
    },
    methods: {
      selectionChanged(params) {
        const permissions = params.selectedRows.map((item) => item.id);
        this.form.items_permission = permissions;
      },
      async resetUser() {
        // Fetch the user.
        await this.$store.dispatch('auth/fetchUser');
      },
      store() {
        window.axios({
          method: this.method,
          url: this.URL,
          data: this.form,
        }).then((result) => {
          this.resetUser();
            this.$router.push({ name: 'users', params: { action: 'created', message: result.data.message } });
        }).catch(() => {
            this.form.busy = false;
        });
      },
      validate() {
        if (this.$refs.form.validate()) {
            this.snackbar = true;
            this.form.busy = true;
            this.store();
        }
      },
      save() {
        this.validate();
      },
      cancel() {
        this.$router.go(-1);
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
      selectRol() {
        if (this.$refs.form.validate()) {
          const url = `/api/maintenance/roles/permissions/${this.form.role}`;
            window.axios.get(url)
            .then((response) => {
           this.items = response.data;
            // ----------------------------------------------------------------
            const categorias = [];
            this.items.forEach((item) => {
              if (!categorias.includes(item.description_category)) {
                categorias.push(item.description_category);
              }
            });
            categorias.forEach((categoria) => {
              const row = { name: categoria, children: [] };
              this.items.forEach((item) => {
                if (categoria === item.description_category) {
                  row.children.push({ id: item.id, name: item.description });
                }
              });
              this.rows.push(row);
            });
            if (this.id) {
              this.rows.forEach((item, index) => {
                const children = item.children.map((child) => child.id);
                this.form.items_permission.forEach((itemPermission) => {
                  if (children.includes(itemPermission)) {
                    const index2 = children.indexOf(itemPermission);
                    this.$set(this.rows[index].children[index2], 'vgtSelected', true);
                  }
                });
              });
            }
            // ----------------------------------------------------------------
            this.loadedPermissions = true;
          });
        }
      },
      validarDatos() {
        if (this.$refs.form.validate()) {
            this.next = 2;
            this.form.role = '';
        }
      },
      validarRol() {
        if (this.$refs.form.validate()) {
            this.next = 3;
        }
      },
      getRoles() {
        const type = 'D';
        const url = `/api/users/getRoles/${type}`;
        return window.axios.get(url);
      },
      getProvincia() {
        const url = '/api/provinces';
        return window.axios.get(url);
      },
      getDistrito() {
        if (this.form.cat_province_id) {
            const url = `/api/districts/${this.form.cat_province_id}`;
            window.axios.get(url)
            .then((response) => {
            this.itemsDistrict = response.data;
          });
        }
      },
      getCorregimiento() {
        if (this.form.cat_district_id) {
            const url = `/api/corregimientos/${this.form.cat_district_id}`;
            window.axios.get(url)
            .then((response) => {
            this.itemsCorregimiento = response.data;
          });
        }
      },
    },
  };

</script>
<style scoped>
  .custom-good-table {
      width: 100%;
  }
</style>
